module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-1-7a393e4f0c1257df54cdbfd90d625dfd.png";